<template>
  <div>
    <TextInput :disabled="data.fullcopy" @setError="errors.name = $event" v-model="data.name" text="ФИО выгодоприобретателя" :name="`beneficiary-${index}-name`" />
    <CheckBox :name="`beneficiary-${index}-fullcopy`" v-model="data.fullcopy" >Заявитель совпадает с&nbsp;выгодоприобритателем</CheckBox>    
    <DateInput :disabled="data.fullcopy" @setError="errors.birthdate = $event" :name="`beneficiary-${index}-birthdate`" text="Дата рождения выгодоприобретателя" :range="false" v-model="data.birthdate" />
    <SelInput :disabled="data.fullcopy" text="Документ удостоверяющий личность" :name="`beneficiary-${index}-doctype`" :options="doctypes" v-model="data.doc.type" />
    <ShortFields>
      <NumberInput :disabled="data.fullcopy" v-if="dynamicfields.series" mask="####" @setError="errors.series = $event" :filled="(v) => v.length == 4" v-model="data.doc.series" text="Серия документа" :name="`beneficiary-${index}-doc-series`" />
      <NumberInput :disabled="data.fullcopy" v-if="dynamicfields.number" mask="######" @setError="errors.number = $event" :filled="(v) => v.length == 6" v-model="data.doc.number" text="Номер документа" :name="`beneficiary-${index}-doc-number`" />
      <TextInput :disabled="data.fullcopy" v-if="dynamicfields.foreignnumber" @setError="errors.number = $event" v-model="data.doc.number" text="Номер документа" :name="`beneficiary-${index}-doc-foreign-number`" />
    </ShortFields>
    <ShortFields>
      <NumberInput :disabled="data.fullcopy" v-if="dynamicfields.code" mask="###-###" @setError="errors.code = $event" :filled="(v) => v.length == 7" v-model="data.doc.code" text="Код подразделения " :name="`beneficiary-${index}-doc-code`" />
      <DateInput :disabled="data.fullcopy" v-if="dynamicfields.releasedate" @setError="errors.releasedate = $event" v-model="data.doc.releasedate" text="Дата выдачи документа" :name="`beneficiary-${index}-doc-releasedate`" />
    </ShortFields>
    <NumberInput mask="############" @setError="errors.INN = $event" :filled="(v) => v.length == 12" v-model="data.INN" text="ИНН выгодоприобретателя" :name="`beneficiary-${index}-INN`" />
    <CheckBox :disabled="data.fullcopy" :name="`beneficiary-${index}-addresscopy`" v-model="data.addresscopy" >Адрес проживания совпадает с адресом заявителя</CheckBox>    
    <TextInput :disabled="data.addresscopy" @setError="errors.address = $event" :options="dadataVariants" v-model="data.address" text="Адрес проживания выгодоприобретателя" :name="`beneficiary-${index}-address`"/>
    <CheckBox :name="`beneficiary-${index}-publicPerson`" v-model="data.publicPerson" >Является публичным должностным лицом</CheckBox>    
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TextInput from '@/components/inputs/TextInput.vue';
import DateInput from '../inputs/DateInput.vue';
import SelInput from '../inputs/SelInput.vue';
import ShortFields from '../ShortFields.vue';
import NumberInput from '../inputs/NumberInput.vue';
import dadataSuggest from '@/mixins/dadataSuggest.js';
import CheckBox from '../inputs/CheckBox.vue';

export default {
  components: { TextInput, DateInput, SelInput, ShortFields, NumberInput, CheckBox },
  mixins: [dadataSuggest],
  props: {
    index: { type: Number, required: true },
    active: { type: Boolean, default: false },
  },
  data: () => ({
    doctypeindex: 0,
    errors: {},
    doctypes: ['','Паспорт гражданина РФ', 'Паспорт иностранного гражданина', 'Иное'],
    dadataVariants: [],
    data: {
      name: '',
      fullcopy: false,
      addresscopy: false,
      birthdate: '',
      doc: {
        type: '',
        series: '',
        number: '',
        code: '',
        releasedate: ''
      },
      address: '',
      INN: '',
      publicPerson: false,
    },
    dynamicfields: {
      series: false,
      number: false,
      foreignnumber: false,
      code: false,
      releasedate: false
    }
  }),
  computed: {
    ...mapState(['form']),
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false
      if (!this.data.name || !this.data.birthdate || !this.data.doc.type)
        return false
      let required = []
      for (let key in this.dynamicfields)
        if (this.dynamicfields[key])
          if (key == 'foreignnumber')
            required.push('number')
          else
            required.push(key)
      if (this.doctypeindex == 1 && !this.data.INN)
        return false
      for (let key of required)
        if (!this.data.doc[key]) return false
      if (!this.data.addresscopy && !this.dadataVariants.includes(this.data.address))
        return false 
      return true
    },
  },
  methods: {
    clearFields(){
      this.data.name = ''
      this.data.birthdate = ''
      this.data.doc.type = ''
      this.data.doc.series = ''
      this.data.doc.number = ''
      this.data.doc.code = ''
      this.data.doc.releasedate = ''
    },
    clearDynamicFields() {
      if (this.data.fullcopy) return
      this.data.doc.number = ''
      this.data.doc.series = ''
      this.data.doc.code = ''
      this.data.doc.releasedate = ''
    },
    setDynamicFields(doctypeindex) {
      this.doctypeindex = doctypeindex

      switch (doctypeindex) {
        case 1:
          return this.dynamicfields = {
            series: true,
            number: true,
            foreignnumber: false,
            code: true,
            releasedate: true
          }
        case 2:
          return this.dynamicfields = {
            series: false,
            number: false,
            foreignnumber: true,
            code: false,
            releasedate: true
          }
        case 0:
        case 3:
          return this.dynamicfields = {
            series: false,
            number: false,
            foreignnumber: false,
            code: false,
            releasedate: false
          }
      }
    },
    copyAddress(){
      this.data.address = this.form.applicant.address
    },
    copyAll(){
      this.data.name = this.form.applicant.name
      this.data.birthdate = this.form.applicant.birthdate
      this.data.doc.type = this.form.applicant.doc.type
      this.data.doc.series = this.form.applicant.doc.series
      this.data.doc.number = this.form.applicant.doc.number
      this.data.doc.code = this.form.applicant.doc.code
      this.data.doc.releasedate = this.form.applicant.doc.releasedate
      this.data.addresscopy = true
    }
  },
  watch: {
    'data.doc.type': function (value, old) {
      if (value != old)
        this.clearDynamicFields()
      for (let i = 0; i < this.doctypes.length; i++)
        if (value == this.doctypes[i])
          return this.setDynamicFields(i)
    },
    filled(v, old) {
      if (v != old)
        this.$emit('filledChanged', v)
    },
    data: {
      handler(v){
        this.$emit('dataChanged', v)
      }, 
      deep: true
    },
    'data.address': async function(val) {
      if (this.data.addresscopy) return
      clearTimeout(this.timer)
      this.timer = setTimeout(async ()=>this.dadataVariants = await this.dadataSuggest(val), 200)
    },
    'data.fullcopy': function (val) {
      if (val) 
        this.copyAll()
      else {
        this.data.addresscopy = false
        this.clearFields()
      }
    },
    'data.addresscopy': function (val) {
      if (val) 
        this.copyAddress()
      else
        this.data.address = '' 
    },
    active(){
      if (this.data.fullcopy)
        this.copyAll()
      if (this.data.addresscopy)
        this.copyAddress()
    }

  }
}
</script>

<style lang="sass">

</style>